function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { ComponentType } from '@wix/ambassador-devcenter-components-v1-component/types';
import { ManifestLifecycle } from './ManifestLifecycle';
import { ManifestHelpers } from './helpers';
import { ManifestUrlResolver } from './ManifestUrlResolver';
import { ManifestComponentExtensionType, ManifestStore } from './ManifestStore';
import { PanelStore } from './PanelStore';
import { ManifestContextService } from './sdk/ManifestContextService';
import { ComponentsService } from './ComponentsService';
import { BlocksWidgetComponentFlow, EditorReactComponentFlow, OOIComponentFlow, SystemComponentFlow } from './flows';
import { createEditorPlatformManifestServicesError, EditorPlatformManifestServicesErrorCode } from './errors';
import { ManifestDefaultValues } from './ManifestDefaultValues';
import { ExternalPresetsHandler, ExternalStateHandler } from './handlers';
import { ManifestContextAPIProvider } from './sdk/ManifestContextAPIProvider';
import { ManifestChangeDetection } from './sdk/ManifestChangeDetection';
import { ExternalAPIHandlers } from './handlers/ExternalAPIHandlers';
var _readyPromiseResolve = /*#__PURE__*/new WeakMap();
var _readyPromise = /*#__PURE__*/new WeakMap();
var _manifestHelpers = /*#__PURE__*/new WeakMap();
var _manifestLifecycle = /*#__PURE__*/new WeakMap();
var _manifestStore = /*#__PURE__*/new WeakMap();
var _panelStore = /*#__PURE__*/new WeakMap();
var _manifestContextService = /*#__PURE__*/new WeakMap();
var _manifestUrlResolver = /*#__PURE__*/new WeakMap();
var _componentsService = /*#__PURE__*/new WeakMap();
var _manifestDefaultValues = /*#__PURE__*/new WeakMap();
var _flows = /*#__PURE__*/new WeakMap();
var _externalAPIHandlers = /*#__PURE__*/new WeakMap();
var _manifestContextAPIProvider = /*#__PURE__*/new WeakMap();
var _ManifestsManager_brand = /*#__PURE__*/new WeakSet();
export class ManifestsManager {
  constructor(dm, hostAPI, events, editorPointerAPI, wixCLIIntegrationAPI) {
    this.dm = dm;
    this.hostAPI = hostAPI;
    this.events = events;
    this.editorPointerAPI = editorPointerAPI;
    this.wixCLIIntegrationAPI = wixCLIIntegrationAPI;
    _classPrivateMethodInitSpec(this, _ManifestsManager_brand);
    _classPrivateFieldInitSpec(this, _readyPromiseResolve, () => {});
    _classPrivateFieldInitSpec(this, _readyPromise, new Promise(resolve => {
      _classPrivateFieldSet(_readyPromiseResolve, this, () => resolve());
    }));
    _classPrivateFieldInitSpec(this, _manifestHelpers, void 0);
    _classPrivateFieldInitSpec(this, _manifestLifecycle, void 0);
    _classPrivateFieldInitSpec(this, _manifestStore, void 0);
    _classPrivateFieldInitSpec(this, _panelStore, void 0);
    _classPrivateFieldInitSpec(this, _manifestContextService, void 0);
    _classPrivateFieldInitSpec(this, _manifestUrlResolver, void 0);
    _classPrivateFieldInitSpec(this, _componentsService, void 0);
    _classPrivateFieldInitSpec(this, _manifestDefaultValues, void 0);
    // @ts-expect-error defined in the constructor
    _classPrivateFieldInitSpec(this, _flows, {});
    _classPrivateFieldInitSpec(this, _externalAPIHandlers, void 0);
    _classPrivateFieldInitSpec(this, _manifestContextAPIProvider, void 0);
    _classPrivateFieldSet(_manifestHelpers, this, new ManifestHelpers(this.dm, this.editorPointerAPI));
    _classPrivateFieldSet(_manifestStore, this, new ManifestStore(_classPrivateFieldGet(_manifestHelpers, this)));
    _classPrivateFieldSet(_manifestUrlResolver, this, new ManifestUrlResolver(this.dm));
    _classPrivateFieldSet(_manifestLifecycle, this, new ManifestLifecycle(this.dm, this.editorPointerAPI));
    _classPrivateFieldSet(_panelStore, this, new PanelStore(_classPrivateFieldGet(_manifestHelpers, this)));
    _classPrivateFieldSet(_manifestDefaultValues, this, new ManifestDefaultValues(new ExternalStateHandler(this.dm, this.hostAPI, _classPrivateFieldGet(_manifestStore, this)), new ExternalPresetsHandler(this.dm, this.hostAPI, _classPrivateFieldGet(_manifestStore, this)), _classPrivateFieldGet(_manifestStore, this), _classPrivateFieldGet(_manifestHelpers, this)));
    _classPrivateFieldSet(_externalAPIHandlers, this, new ExternalAPIHandlers(this.dm, this.hostAPI, _classPrivateFieldGet(_manifestStore, this), _classPrivateFieldGet(_manifestDefaultValues, this)));
    _classPrivateFieldSet(_manifestContextAPIProvider, this, new ManifestContextAPIProvider(_classPrivateFieldGet(_externalAPIHandlers, this).query, _classPrivateFieldGet(_externalAPIHandlers, this).resolver, _classPrivateFieldGet(_manifestStore, this), this.editorPointerAPI));
    _classPrivateFieldSet(_manifestContextService, this, new ManifestContextService(_classPrivateFieldGet(_manifestContextAPIProvider, this), new ManifestChangeDetection(this.events), this.editorPointerAPI));
    _classPrivateFieldSet(_componentsService, this, new ComponentsService(this.dm, this.hostAPI, _classPrivateFieldGet(_manifestContextAPIProvider, this), _classPrivateFieldGet(_manifestStore, this), _classPrivateFieldGet(_panelStore, this), _classPrivateFieldGet(_manifestLifecycle, this), this.editorPointerAPI, _classPrivateFieldGet(_manifestDefaultValues, this)));
    [EditorReactComponentFlow, BlocksWidgetComponentFlow, OOIComponentFlow].forEach(Factory => {
      const instance = new Factory(this.dm, this.editorPointerAPI, _classPrivateFieldGet(_manifestUrlResolver, this), _classPrivateFieldGet(_manifestStore, this), _classPrivateFieldGet(_panelStore, this), this.wixCLIIntegrationAPI);
      _classPrivateFieldGet(_flows, this)[instance.type] = instance;
    });
  }
  start() {
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    _classPrivateFieldGet(_manifestLifecycle, this).onManifestLoad(async x => {
      try {
        await _classPrivateFieldGet(_readyPromise, this);
        await _assertClassBrand(_ManifestsManager_brand, this, _processManifest).call(this, x);
      } catch (e) {
        throw e;
      }
    });
    _classPrivateFieldGet(_manifestLifecycle, this).onPanelLoad(async x => {
      try {
        await _classPrivateFieldGet(_readyPromise, this);
        await _assertClassBrand(_ManifestsManager_brand, this, _processComponentPanel).call(this, x);
      } catch (e) {
        throw e;
      }
    });
    void _assertClassBrand(_ManifestsManager_brand, this, _loadInitialData).call(this);
    _classPrivateFieldGet(_manifestLifecycle, this).startListeners();
  }
  getManifest(compType) {
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    return _classPrivateFieldGet(_manifestStore, this).getManifest(compType);
  }
  getManifestByEditorPointer(editorPointer) {
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    return _classPrivateFieldGet(_manifestStore, this).getManifestByEditorPointer(editorPointer);
  }
  getPanel(compType, actionName) {
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    return _classPrivateFieldGet(_panelStore, this).getPanel(compType, actionName);
  }
  getContextualManifest(manifestContextId) {
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    return _classPrivateFieldGet(_manifestContextService, this).getContextualManifest(manifestContextId);
  }
  getContextualRuntimeContext(manifestContextId) {
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    return _classPrivateFieldGet(_manifestContextService, this).getContextualRuntimeContext(manifestContextId);
  }
  getContextualManifestResolver(manifestContextId, childPath) {
    if (childPath === void 0) {
      childPath = [];
    }
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    return _classPrivateFieldGet(_manifestContextService, this).getContextualManifestResolver(manifestContextId, childPath);
  }
  getContextualManifestQuery(manifestContextId, childPath) {
    if (childPath === void 0) {
      childPath = [];
    }
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    return _classPrivateFieldGet(_manifestContextService, this).getContextualManifestQuery(manifestContextId, childPath);
  }
  onContextualManifestChange(manifestContextId, cb) {
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    return _classPrivateFieldGet(_manifestContextService, this).onChange(manifestContextId, cb);
  }
  replaceManifestContext(manifestId, cb) {
    const context = _classPrivateFieldGet(_manifestContextService, this).buildManifestContext(cb);
    if (context) {
      _classPrivateFieldGet(_manifestContextService, this).replaceManifestContext(manifestId, context);
    } else {
      console.warn(createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ManifestContextBuild, 'manifest context was built to replace but it is empty'));
    }
  }
  buildManifestContext(cb) {
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    const context = _classPrivateFieldGet(_manifestContextService, this).buildManifestContext(cb);
    if (context) {
      _classPrivateFieldGet(_manifestContextService, this).registerContext(context);
    } else {
      console.warn(createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ManifestContextBuild, 'manifest context was built but it is empty'));
    }
    return (context == null ? void 0 : context.manifestId) ?? null;
  }
  getComponentsService() {
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    return _classPrivateFieldGet(_componentsService, this);
  }
  getBuilderManifests() {
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    return _classPrivateFieldGet(_manifestStore, this).getAll();
  }
  getBuilderPanels() {
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    return _classPrivateFieldGet(_panelStore, this).getAll();
  }
  getSDKRuntimeContexts() {
    _assertClassBrand(_ManifestsManager_brand, this, _assertReady).call(this);
    return _classPrivateFieldGet(_manifestContextService, this).getAllRuntimeContexts();
  }
}
function _assertReady() {
  if (!this.editorPointerAPI) {
    throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.Internal, 'editor pointer API is not available, manifest services are not functional');
  }
}
async function _loadInitialData() {
  await Promise.all([_assertClassBrand(_ManifestsManager_brand, this, _processSystemComponents).call(this)]);
  _classPrivateFieldGet(_readyPromiseResolve, this).call(this);
}
async function _processManifest(props) {
  // if (this.#manifestStore.has(props.compType) && !props.force) {
  //   return;
  // }

  switch (props.appDataComponent.type) {
    case ComponentType.EDITOR_REACT_COMPONENT:
      {
        await _classPrivateFieldGet(_flows, this)[ManifestComponentExtensionType.BUILDER].loadManifest(props);
        break;
      }
    case ComponentType.STUDIO_WIDGET:
      {
        await _classPrivateFieldGet(_flows, this)[ManifestComponentExtensionType.BLOCKS].loadManifest(props);
        break;
      }
    case ComponentType.PAGE_OUT_OF_IFRAME:
    case ComponentType.PAGE:
    case ComponentType.WIDGET:
    case ComponentType.WIDGET_OUT_OF_IFRAME:
      {
        // change ManifestComponentExtensionType to LegacyComponentFlow
        await _classPrivateFieldGet(_flows, this)[ManifestComponentExtensionType.OOI].loadManifest(props);
        break;
      }
  }
}
async function _processSystemComponents() {
  const systemFlow = new SystemComponentFlow(this.dm, this.editorPointerAPI, _classPrivateFieldGet(_manifestUrlResolver, this), _classPrivateFieldGet(_manifestStore, this), _classPrivateFieldGet(_panelStore, this), this.wixCLIIntegrationAPI);
  const compTypes = Object.entries(_classPrivateFieldGet(_manifestStore, this).getAll()).filter(_ref => {
    let [, value] = _ref;
    return value.extensionType === ManifestComponentExtensionType.SYSTEM;
  }).map(_ref2 => {
    let [key] = _ref2;
    return key;
  });
  const results = await Promise.allSettled(compTypes.map(compType => systemFlow.loadPanelsByCompType({
    compType
  })));
  const failedCompTypes = results.map((result, idx) => result.status === 'rejected' ? compTypes[idx] : null).filter(Boolean);
  if (failedCompTypes.length > 0) {
    console.error(`Failed to load panels for compTypes: ${failedCompTypes.join(', ')}`);
  }
}
async function _processComponentPanel(props) {
  switch (props.appDataComponent.type) {
    case ComponentType.EDITOR_REACT_COMPONENT:
      {
        await _classPrivateFieldGet(_flows, this)[ManifestComponentExtensionType.BUILDER].loadPanels(props);
        break;
      }
    case ComponentType.STUDIO_WIDGET:
      {
        await _classPrivateFieldGet(_flows, this)[ManifestComponentExtensionType.BLOCKS].loadPanels(props);
        break;
      }
    case ComponentType.PAGE_OUT_OF_IFRAME:
    case ComponentType.WIDGET_OUT_OF_IFRAME:
      {
        await _classPrivateFieldGet(_flows, this)[ManifestComponentExtensionType.OOI].loadPanels(props);
        break;
      }
  }
}
//# sourceMappingURL=ManifestsManager.js.map